import {
  Component,
  inject,
  ViewChild,
  OnInit,
  DestroyRef,
} from '@angular/core';

import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';

import {
  BuildingModalComponent,
  Building,
  QrListComponent,
  Business,
} from '../../../index';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { BuildingService, BusinessService } from '../../../services';
import { ModalAlertComponent } from '@shared/components';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastAlertService } from '@core/services';
import { UpperCasePipe } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SearchFieldComponent } from '@shared/components/search-field/search-field.component';
import { ToolbarComponent } from '@shared/components/toolbar/toolbar.component';

@Component({
  templateUrl: './building-page.component.html',
  styles: [],
  standalone: true,
  imports: [
    ToolbarComponent,
    SearchFieldComponent,
    ButtonComponent,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatPaginatorModule,
    UpperCasePipe,
  ],
})
export class BuildingPageComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  displayedColumns: string[] = [
    'name',
    'code',
    'address',
    'city',
    'business',
    'options',
  ];
  dataSource: MatTableDataSource<Building>;
  fielInput!: string;
  private dialog = inject(MatDialog);
  private buildingService = inject(BuildingService);
  private destroyRef = inject(DestroyRef);
  private alertService = inject(ToastAlertService);

  private _router = inject(Router);
  private _activatedRoute = inject(ActivatedRoute);
  private _business = inject(BusinessService);
  public currentBusiness: Business | null = null;

  private selectedBusinessId: number | null = null;
  public pageSubTitle: string = '';
  private SelectLogoSysAdmin: number = -1;

  constructor() {
    this.dataSource = new MatTableDataSource();
  }

  async ngOnInit() {
    await this._activatedRoute.params.subscribe((parms: any) => {
      this.selectedBusinessId = parms.id;
    });
    if (this.selectedBusinessId != null) {
      await this._business
        .getBusinessByID(this.selectedBusinessId)
        .subscribe((response: any) => {
          console.log(response, 'DATOS DE BUSINESS');
          if (response.status == 'OK') {
            this.currentBusiness = <Business>response.reply[0];
            console.log('BUSINESS', this.currentBusiness);
            this.SelectLogoSysAdmin = response.reply[0].logo_id;
            console.log(
              this.SelectLogoSysAdmin,
              'recuperando el dato de logo_id'
            );
            this.pageSubTitle = this.currentBusiness.name;
          }
        });
    }

    this.chargueBuildings();
  }

  chargueBuildings() {
    if (this.selectedBusinessId != null) {
      this.buildingService
        .getBuildingsByBusiness(this.selectedBusinessId)
        .subscribe((response: any) => {
          if (response.status == 'OK') {
            this.dataSource = new MatTableDataSource(response.reply);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          }
        });
    } else {
      this.buildingService
        .getBuildings()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (resp: any) => {
            if (resp.status == 'OK') {
              this.dataSource = new MatTableDataSource(resp.reply);
              this.dataSource.paginator = this.paginator;
              this.dataSource.sort = this.sort;
            }
          },
        });
    }
  }

  modalAction(action?: any) {
    if (
      typeof action != 'undefined' &&
      action != null &&
      this.selectedBusinessId != null
    ) {
      action.idBusiness = this.selectedBusinessId;
      action.toEdit = true;
    } else {
      action = {
        idBusiness: this.selectedBusinessId,
      };
      action.toEdit = false;
    }
    let width: string;

    if (window.innerWidth <= 768) {
      width = '90%';
    } else {
      width = '50%';
    }

    const dialogActionDetail = this.dialog.open(BuildingModalComponent, {
      width: width,
      data: action,
      disableClose: true,
    });

    dialogActionDetail
      .beforeClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if (result) {
          this.chargueBuildings();
        }
      });
  }

  modalDelete(theme: Building) {
    const dialogDelete = this.dialog.open(ModalAlertComponent, {
      data: theme.name,
    });
    dialogDelete
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result: boolean) => {
        if (!result) return;
        this.buildingService
          .deleteBuilding(theme.buildingid)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: resp => {
              if (resp.status === 'OK') {
                this.chargueBuildings();
                this.alertService.sucess(
                  `El Edificio ${theme.name} fue eliminado exitosamente`
                );
              } else {
                this.alertService.error(
                  'Ha ocurrido un error, inténtelo de nuevo'
                );
              }
            },
            error: error => {
              this.alertService.error(`Error: ${error}`);
            },
          });
      });
  }

  modalQR(building: Building) {
    building.logo_id = this.SelectLogoSysAdmin;
    console.log(building.logo_id, 'logo_id lo esta mandando en modal de qr');
    this.dialog.open(QrListComponent, {
      width: '65rem',
      height: '35rem',
      maxWidth: 'none',
      panelClass: 'custom-modal',
      data: building,
    });
    console.log(building, 'esto trae edificio');
  }

  gotToBuildingFloors(building: any) {
    console.log(building);

    const navigationExtras: NavigationExtras = {
      state: {
        businessData: this.currentBusiness,
      },
    };

    this._router.navigate(
      ['/admin/general/floors', building.buildingid],
      navigationExtras
    );
  }
}
